import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

import withDashboardSidebar from '../../components/with-dashboard-sidebar';

/* eslint-disable import/no-unresolved */
const Draft = React.lazy(() => import('playbook-mf-create-project/ProjectDraft'));

function ProjectDraft(props) {
  const { match } = props;
  return (
    <Suspense>
      <Draft match={match} />
    </Suspense>
  );
}

ProjectDraft.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default withDashboardSidebar(ProjectDraft);
